import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import FAQSchema from '../../../components/feature/FAQSchema';
import { useEffect } from 'react';

export default function TuzlaPage() {
  useEffect(() => {
    document.title = 'Tuzla Fiber Optik ve Güvenlik Sistemleri | Tuzla Fiber Ustası - Fiber Ek';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Tuzla fiber ustası, fiber kablo tamiri, fusion splicing, OTDR test, IP kamera sistemleri. Tuzla OSB fabrika fiber altyapı ve güvenlik çözümleri.');
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Tuzla Fiber Optik ve Güvenlik Sistemleri | Fiber Ek');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Tuzla Fiber Optik ve Güvenlik Sistemleri | Fiber Ek';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/bolgeler/tuzla');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/bolgeler/tuzla';
      document.head.appendChild(meta);
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/bolgeler/tuzla');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/bolgeler/tuzla';
      document.head.appendChild(link);
    }

    // LocalBusiness Schema
    const schemaId = 'tuzla-local-business-schema';
    if (!document.getElementById(schemaId)) {
      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Fiber Ek - Tuzla Fiber Optik ve Güvenlik Sistemleri",
        "url": "https://fiberek.com/bolgeler/tuzla",
        "telephone": "+90 553 716 55 61",
        "email": "info@fiberek.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Güneşli Mah. 1272. Sk. No: 1 İç Kapı No: 7",
          "addressLocality": "Bağcılar",
          "addressRegion": "İstanbul",
          "addressCountry": "TR"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "40.8228",
          "longitude": "29.2889"
        },
        "areaServed": {
          "@type": "City",
          "name": "Tuzla"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        ],
        "sameAs": ["https://wa.me/905537165561"],
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://fiberek.com/" },
            { "@type": "ListItem", "position": 2, "name": "Bölgeler", "item": "https://fiberek.com/bolgeler" },
            { "@type": "ListItem", "position": 3, "name": "Tuzla", "item": "https://fiberek.com/bolgeler/tuzla" }
          ]
        }
      });
      document.head.appendChild(script);
    }

    return () => {
      document.title = 'Fiber Ek';
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  const faqs = [
    {
      question: 'Tuzla\'da fiber ustası hizmeti veriyor musunuz?',
      answer: 'Evet, Tuzla fiber ustası ekibimiz 10+ yıllık tecrübesiyle fiber kablo tamiri, fusion splicing ve fiber optik sonlandırma hizmetleri sunuyor. 7/24 acil fiber arıza müdahale hizmeti veriyoruz.'
    },
    {
      question: 'Tuzla OSB\'de fabrika fiber altyapı kurulumu yapıyor musunuz?',
      answer: 'Evet, Tuzla Organize Sanayi Bölgesi\'nde fabrika fiber altyapı kurulumu, bina fiber kablo tamiri ve metro ethernet fiber ek hizmetleri sunuyoruz. OM3 OM4 fiber ek işlemlerinde uzmanız.'
    },
    {
      question: 'Tuzla\'da hangi güvenlik sistemlerini kuruyorsunuz?',
      answer: 'Tuzla\'da IP kamera sistemleri, hırsız alarm sistemleri, yangın alarm sistemleri, geçiş kontrol sistemleri, turnike ve bariyer sistemleri kurulumu yapıyoruz. Özellikle tersane ve fabrikalar için özel güvenlik projeleri geliştiriyoruz.'
    },
    {
      question: 'SC LC konnektör sonlandırma işlemi ne kadar sürer?',
      answer: 'SC LC konnektör sonlandırma işlemi genellikle 30-60 dakika içinde tamamlanır. Her sonlandırma sonrası OTDR test ile kayıp değerlerini ölçüyor ve raporluyoruz.'
    }
  ];

  return (
    <>
      <FAQSchema faqs={faqs} />
      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
        <Navbar />
        <FloatingButtons />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/42289804a6d3ecf67ac8fc91fc8e0e63.jpg')] bg-cover bg-center opacity-20"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 via-transparent to-slate-900/50"></div>
          
          <div className="container mx-auto px-4 relative z-10">
            <Breadcrumb 
              items={[
                { label: 'Ana Sayfa', path: '/' },
                { label: 'Bölgeler', path: '/' },
                { label: 'Tuzla', path: '/locations/tuzla' }
              ]} 
            />

            <div className="max-w-4xl mx-auto text-center mt-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                Tuzla Fiber Optik ve Güvenlik Sistemleri
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Tuzla OSB ve Sanayi Bölgelerinde Profesyonel Fiber Ustası, Fiber Kablo Tamiri ve Güvenlik Çözümleri
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a 
                  href="tel:+905537165561"
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Hemen Ara
                </a>
                <a 
                  href="https://wa.me/905537165561"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-slate-800/50">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              
              {/* Fiber Optik Hizmetleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-flashlight-line text-blue-500"></i>
                  Tuzla Fiber Optik Hizmetleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Tuzla'da <strong>Tuzla fiber ustası</strong> ekibimizle <strong>fiber kablo tamiri</strong>, <strong>fiber optik sonlandırma</strong> ve <strong>fusion splicing hizmeti</strong> sunuyoruz. Tuzla OSB, tersane bölgesi ve sanayi alanlarında 10+ yıllık tecrübemizle <strong>fabrika fiber altyapı</strong> kurulumu ve <strong>acil fiber arıza</strong> müdahalei veriyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Tuzla Fiber Ustası ve Fiber Kablo Tamiri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Tuzla fiber ustası</strong> ekibimiz, tersane ve fabrika bölgelerinde yaşanan fiber arızalarına anında müdahale ediyor. <strong>Fiber kablo tamiri</strong> konusunda uzman kadromuz, kesilen veya hasarlı fiber kablolarınızı profesyonel fusion splicing cihazlarıyla onarıyor. <strong>OTDR test hizmeti</strong> ile fiber hattınızdaki kayıp değerlerini ölçüyor ve raporluyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Fabrika Fiber Altyapı ve Fiber Ek Hizmeti</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Tuzla OSB'deki fabrikalarda <strong>fabrika fiber altyapı</strong> projeleri gerçekleştiriyoruz. <strong>Fiber ek hizmeti</strong> ile yüksek hızlı internet altyapısı kuruyoruz. <strong>OM3 OM4 fiber ek</strong> işlemlerinde uluslararası standartlara uygun çalışıyoruz. <strong>SC LC konnektör sonlandırma</strong> ve <strong>metro ethernet fiber ek</strong> projelerinde minimum kayıp garantisi veriyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Bina Fiber Kablo Tamiri ve OTDR Test</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Tuzla'daki iş merkezleri ve konut projelerinde <strong>bina fiber kablo tamiri</strong> hizmeti sunuyoruz. <strong>OTDR test hizmeti</strong> ile fiber altyapınızın sağlık durumunu kontrol ediyor, zayıf noktaları tespit ediyoruz. Önleyici bakım önerileriyle fiber hattınızın ömrünü uzatıyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/fiber-services/fiber-cable-repair" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-tools-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fiber Kablo Tamiri</h4>
                    <p className="text-gray-400 text-sm">Tuzla OSB acil müdahale</p>
                  </Link>
                  <Link to="/fiber-services/otdr-test" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-line-chart-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">OTDR Test</h4>
                    <p className="text-gray-400 text-sm">Fiber hat analizi ve raporlama</p>
                  </Link>
                </div>
              </div>

              {/* Güvenlik Sistemleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-shield-check-line text-blue-500"></i>
                  Tuzla Güvenlik Sistemleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Tuzla'da <strong>IP kamera sistemleri</strong>, <strong>hırsız alarm sistemleri</strong>, <strong>yangın alarm sistemleri</strong>, <strong>geçiş kontrol sistemleri</strong>, <strong>turnike sistemleri</strong> ve <strong>bariyer sistemleri</strong> kurulumu yapıyoruz. Tersane ve fabrikalar için özel güvenlik projeleri sunuyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Tersane ve Fabrika Güvenlik Sistemleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Tuzla tersane bölgesi ve OSB'deki fabrikalarda yüksek güvenlikli <strong>IP kamera sistemleri</strong> kuruyoruz. Geniş alan kameraları, PTZ kameralar ve gece görüş teknolojisi ile 7/24 izleme sağlıyoruz. <strong>Geçiş kontrol sistemleri</strong> ile personel ve araç giriş-çıkışlarını yönetiyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/security-systems/ip-camera-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-camera-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">IP Kamera Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Tersane ve fabrika güvenliği</p>
                  </Link>
                  <Link to="/security-systems/barrier-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-roadster-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Bariyer Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Araç giriş kontrol çözümleri</p>
                  </Link>
                </div>
              </div>

              {/* FAQ */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-8">Sıkça Sorulan Sorular</h2>
                <div className="space-y-6">
                  {faqs.map((faq, index) => (
                    <div key={index} className="border-b border-slate-700/50 pb-6 last:border-0">
                      <h3 className="text-xl font-bold text-white mb-3">{faq.question}</h3>
                      <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-20 bg-slate-900/30">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl font-bold text-white mb-8 text-center">Konum</h2>
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d97174.23958425012!2d29.2889!3d40.8228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cb2e2e2e2e2e2e%3A0x2e2e2e2e2e2e2e2e!2sTuzla!5e0!3m2!1str!2str!4v1234567894"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Tuzla Harita"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}